import { flow } from "fp-ts/lib/function";

import { type MetricField } from "../../gql-generated/types";
import { type InsightsMetricsMap, type StatsItem } from "../models";

import { mapDiffValue } from "./mapDiffValue";
import { mapTotalValueFormatted } from "./mapTotalValueFormatted";

export const mapTotalMetricsData = (
    metricFields: MetricField[],
    totalMap: InsightsMetricsMap<StatsItem>,
    previousTotalMap?: InsightsMetricsMap<StatsItem>,
): { totalMetrics: InsightsMetricsMap<StatsItem> } => {
    const totalMetrics: InsightsMetricsMap<StatsItem> = Object.fromEntries(
        metricFields.map((metricField) => {
            const metric = flow(
                mapTotalValueFormatted(metricField),
                mapDiffValue(previousTotalMap?.[metricField]),
            )(totalMap[metricField]);

            return [metricField, metric];
        }),
    );

    return {
        totalMetrics,
    };
};
